import { signout, isAuth } from './auth'; // Adjust path if needed
import { Component, ChangeDetectionStrategy, signal, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <nav class="px-0 navbar navbar-expand-lg border-none" style="z-index: 12; position: absolute; width: 100%; background: rgba(255, 255, 255, 0); box-shadow:none">
      <!-- Añadimos 'justify-content-between' para forzar extremos opuestos en pantallas pequeñas -->
      <div class="px-1 container justify-content-between">

      <div class="d-flex container justify-content-between">
        <!-- 1. Marca / Logo (A la izquierda) -->
        <a class="navbar-brand" routerLink="/" (click)="closeMenu()">
                <i class="bi bi-house" style="color: #9500ff; font-size: 34px;"></i>
        </a>

        <!-- 2. Botón Hamburguesa (A la derecha) -->
        <button
          class="navbar-toggler"
          type="button"
          (click)="toggleMenu()"
          [attr.aria-expanded]="isMenuOpen()"
          aria-label="Alternar navegación">
            <i class="bi bi-list" style="color: #9500ff; font-size: 34px;"></i>
        </button>
      </div>

        <!-- 3. Contenido colapsable (Menú de navegación) -->
        <div class="collapse navbar-collapse flex-grow-0 pl-2" [class.show]="isMenuOpen()">
          <ul class="navbar-nav ms-auto mb-lg-0 custom-nav-links" style="font-size: 18px">
          <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/land"
                routerLinkActive="active"
                (click)="closeMenu()">
                Vector
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/documentos"
                routerLinkActive="active"
                (click)="closeMenu()">
                Documentos
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/panel"
                routerLinkActive="active"
                (click)="closeMenu()">
                Panel
              </a>
            </li>
@if (auth) {
            <li class="nav-item">
              <a
                class="nav-link"
                role="button"
                (click)="onSignOut()">
                Cerrar
              </a>
            </li>
 } @else {
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/login"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMenu()">
                Iniciar
              </a>
            </li>

          }

          </ul>
        </div>

      </div>
    </nav>
  `,
  styles: [`
    .custom-nav-links .nav-link {
      color: #9500ff !important; /* Cambia este color según prefieras */
    }
    .custom-nav-links .nav-link:hover {
      color: #b033ff !important; /* Color al pasar el cursor opcional */
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Navbar {
  private readonly router = inject(Router);
  readonly isMenuOpen = signal(false);

  toggleMenu(): void {
    this.isMenuOpen.update((isOpen) => !isOpen);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  onSignOut(): void {
    signout(() => {
      this.auth = isAuth();
      this.closeMenu();
      this.router.navigate(['/']);
    });
  }

  auth: any = isAuth();
}